/* CarWrapVinyl.com — "Wrapped for Success" video series (Builder B).
   Click an episode card -> modal with the youtube-nocookie player (autoplay=1).
   Vanilla JS, one namespace: window.CWV.videoSeries. Works with several instances per page. */
(function () {
  'use strict';

  var CWV = (window.CWV = window.CWV || {});
  if (CWV.videoSeries) return;

  var doc = document;
  var YT_ID = /^[A-Za-z0-9_-]{6,20}$/;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  function lockScroll(on) {
    if (typeof CWV.lockScroll === 'function') { CWV.lockScroll(on); return; }
    doc.documentElement.classList[on ? 'add' : 'remove']('cwv-scroll-lock');
  }

  /* Accessible modal on top of <dialog>: focus trap, Esc, backdrop click, focus return, scroll lock. */
  function makeDialog(d, onClose) {
    var opener = null, open = false;
    var SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),iframe,[tabindex]:not([tabindex="-1"])';
    function items() { return $$(SEL, d).filter(function (el) { return el.getClientRects().length > 0; }); }
    function finish() {
      open = false;
      lockScroll(false);
      if (onClose) onClose();
      if (opener && doc.contains(opener)) focusEl(opener);
      opener = null;
    }
    d.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); api.close(); return; }
      if (e.key !== 'Tab') return;
      var list = items();
      if (!list.length) { e.preventDefault(); return; }
      var first = list[0], last = list[list.length - 1], a = doc.activeElement;
      if (e.shiftKey && (a === first || !d.contains(a))) { e.preventDefault(); focusEl(last); }
      else if (!e.shiftKey && (a === last || !d.contains(a))) { e.preventDefault(); focusEl(first); }
    });
    d.addEventListener('cancel', function (e) { e.preventDefault(); api.close(); });
    d.addEventListener('close', function () { if (open) finish(); });
    d.addEventListener('click', function (e) {
      var t = e.target;
      if (t === d || (t && t.hasAttribute && t.hasAttribute('data-cwv-backdrop'))) { api.close(); return; }
      var c = t && t.closest ? t.closest('[data-cwv-close]') : null;
      if (c && d.contains(c)) api.close();
    });
    var api = {
      open: function (from) {
        if (open) return;
        opener = from || doc.activeElement;
        open = true;
        if (typeof d.showModal === 'function') { try { d.showModal(); } catch (e) { d.setAttribute('open', ''); } }
        else d.setAttribute('open', '');
        lockScroll(true);
        focusEl($('[data-cwv-autofocus]', d) || items()[0]);
      },
      close: function () {
        if (!open) return;
        if (typeof d.close === 'function' && d.open) { try { d.close(); } catch (e) { d.removeAttribute('open'); } }
        else d.removeAttribute('open');
        if (open) finish();
      },
      isOpen: function () { return open; }
    };
    return api;
  }

  function Series(root) {
    this.root = root;
    var d = (this.dlgEl = $('[data-cwv-dialog]', root));
    if (!d) return;
    var self = this;
    this.frame = $('[data-cwv-stage]', d);
    this.titleEl = $('[data-cwv-d-title]', d);
    this.metaEl = $('[data-cwv-d-meta]', d);
    this.ytLink = $('[data-cwv-d-yt]', d);
    this.dlg = makeDialog(d, function () { if (self.frame) self.frame.innerHTML = ''; });

    this.onClick = function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-cwv-ep]') : null;
      if (!b || !root.contains(b) || d.contains(b)) return;
      e.preventDefault();
      self.open(b);
    };
    root.addEventListener('click', this.onClick);
  }

  Series.prototype.open = function (btn) {
    var id = (btn.getAttribute('data-yt') || '').trim();
    var title = btn.getAttribute('data-title') || 'Wrapped for Success';
    var watch = 'https://www.youtube.com/watch?v=' + encodeURIComponent(id);
    if (!YT_ID.test(id)) { window.open(watch, '_blank', 'noopener'); return; }

    var f = doc.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
    f.title = title + ' (YouTube video)';
    f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('loading', 'lazy');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

    if (this.titleEl) this.titleEl.textContent = title;
    if (this.metaEl) this.metaEl.textContent = btn.getAttribute('data-meta') || '';
    if (this.ytLink) this.ytLink.href = watch;
    if (this.frame) { this.frame.innerHTML = ''; this.frame.appendChild(f); }
    this.dlg.open(btn);
  };

  Series.prototype.destroy = function () {
    if (this.dlg && this.dlg.isOpen()) this.dlg.close();
    if (this.onClick) this.root.removeEventListener('click', this.onClick);
  };

  function init(scope) {
    $$('[data-cwv-video-series]', scope).forEach(function (el) { if (!el.cwvSeries) el.cwvSeries = new Series(el); });
  }
  function destroy(scope) {
    $$('[data-cwv-video-series]', scope).forEach(function (el) {
      if (el.cwvSeries && el.cwvSeries.destroy) el.cwvSeries.destroy();
      el.cwvSeries = null;
    });
  }

  CWV.videoSeries = { init: init, destroy: destroy };

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);

  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  doc.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
  doc.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('[data-cwv-video-series]') && t.scrollIntoView) {
      try { t.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) { t.scrollIntoView(); }
    }
  });
})();
